import React, { createContext, useContext, useState, useCallback } from "react";

const AlertContext = createContext();

export default function AlertProvider({ children }) {
  const [feedbackAlert, setAlert] = useState({
    active: false,
    text: "",
    color: "",
    severity: "",
    icon: "",
    duration: 2000,
  });
  const [activeAtentionClass, setActiveAtentionClass] = useState("");

  const clearAlert = useCallback(() => {
    setAlert((prev) => ({
      ...prev,
      active: false,
    }));
  }, []);

  return (
    <AlertContext.Provider
      value={{
        feedbackAlert,
        setAlert,
        clearAlert,
        activeAtentionClass,
        setActiveAtentionClass,
      }}
    >
      {children}
    </AlertContext.Provider>
  );
}

export function useAlert() {
  const context = useContext(AlertContext);
  const {
    feedbackAlert,
    setAlert,
    clearAlert,
    activeAtentionClass,
    setActiveAtentionClass,
  } = context;
  return {
    feedbackAlert,
    setAlert,
    clearAlert,
    activeAtentionClass,
    setActiveAtentionClass,
  };
}
